import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Constant} from '../util/constant';
import {catchError, retry} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class AgencyContactsService {
    httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'})};

    constructor(private httpClient: HttpClient) {
    };

    deleteByIdAgencyContacts(agencyContactsId): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'AgencyContacts/deleteAgencyContacts', {'agencyContactsId': agencyContactsId}, this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    countAgencyContacts(agencyContacts): Observable<number> {
        return this.httpClient.post<number>(Constant.BASE_URL + 'AgencyContacts/count', {'agencyContacts': agencyContacts},
                                            this.httpOptions
        ).pipe(retry(3), catchError(Constant.handleError));
    }

    updateAgencyContacts(agencyContacts): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'AgencyContacts/updateAgencyContacts', [agencyContacts], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    addAgencyContacts(agencyContacts): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'AgencyContacts/addAgencyContacts', [agencyContacts], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    findAllAgencyContacts(agencyContacts, pageNo: number, itemsPerPage: number): Observable<string[]> {
        return this.httpClient.post<string[]>(
            Constant.BASE_URL + 'AgencyContacts/findAllAgencyContacts',
            {'agencyContacts': agencyContacts, 'pagination': {'pageNo': pageNo, 'itemsPerPage': itemsPerPage}}, this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }

}
